import { Components } from '.generated/templates/Feature.Components.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import RichTextA11yWrapper from 'components/helpers/RichTextA11yWrapper';
import ImageWrapper from 'components/helpers/ImageWrapper/ImageWrapper';
import { classnames } from 'tailwindcss-classnames';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';

type icons = Sitecore.Override.ItemEx &
  Components.General.IconPanel.Fields.IconItem & {
    id: string;
  };
export type IconPanelProps = Sitecore.Override.ComponentBase &
  Components.General.IconPanel.Fields.IconPanel & {
    fields: {
      selectIcons: icons[];
    };
  };

const textCenter = `text-center`;

const IconPanel = ({ fields }: IconPanelProps) => {
  const isEE = useExperienceEditor();

  // Fail out if we don't have any fields
  if (!fields) {
    return <MissingDataSource />;
  }
  const headingClass = classnames(
    'mb-14',
    textCenter,
    'font-bold',
    'text-2xl',
    'leading-9',
    'sm:text-4xl',
    'sm:leading-11',
    'sm:mb-8'
  );
  return (
    <div data-component="authorable/general/iconpanel">
      {(isEE || fields.heading?.value) && (
        <div className={classnames('row-auto')}>
          <h2 className={classnames(headingClass)}>
            <Text field={fields.heading} />
          </h2>
        </div>
      )}
      <div className={classnames('flex', 'flex-wrap', 'grid-cols-5', 'lg:justify-center')}>
        {fields.selectIcons.map((iconItem: icons) => (
          <div
            key={iconItem.id}
            className={classnames(
              'lg:w-1/5',
              'pr-4',
              'pl-4',
              'pr-4',
              'pl-4',
              'w-1/2',
              textCenter,
              'mb-8',
              'lg:mb-0',
              'last:mb-0'
            )}
          >
            <div className={classnames('max-w-[125px]', 'max-h-[125px]', 'm-auto')}>
              <ImageWrapper field={iconItem.fields.iconImage} layout="responsive" />
            </div>
            <div>
              <h3
                className={classnames(
                  'font-bold',
                  'text-2xl',
                  'leading-9',
                  'sm:text-4xl',
                  'sm:leading-11',
                  'mt-6',
                  'mb-1',
                  textCenter
                )}
              >
                <Text field={iconItem.fields.iconHeading} />
              </h3>
              <div>
                <RichTextA11yWrapper
                  className={classnames('text-theme-text', 'rte')}
                  field={iconItem.fields.iconBody}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IconPanel;
